import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import "./sidebar.css";
import SignLogo from "../../assets/images/logo.png";
import { MdDashboardCustomize } from "react-icons/md";
import { LuActivity, LuChartColumnIncreasing } from "react-icons/lu";
import { IoWalletOutline } from "react-icons/io5";
import { LuRepeat } from "react-icons/lu";
import { PiHandWithdraw, PiHandDeposit } from "react-icons/pi";
import { GoPlus } from "react-icons/go";
import { RiFundsFill } from "react-icons/ri";
import { ImUsers } from "react-icons/im";
const Sidebar = ({ sidebarOpen, toggleSidebar }) => {
  const location = useLocation(); // to get the current URL path
  const [activePath, setActivePath] = useState("");

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location]);

  const authDataString = localStorage.getItem("adminauthor");

  const authData = JSON.parse(authDataString);
  const role = authData?.admin?.role;

  return (
    <nav id="sidebar" className={sidebarOpen ? "active" : ""}>
      <div className="custom-menu">
        <button type="button" id="closeSidebar" onClick={toggleSidebar}>
          <IoClose />
        </button>
      </div>

      <div className="py-2">
        <div className="my-2">
          <Link to="/dashboard/admin">
            <img className="sidebar-logo" src={SignLogo} alt="logo" />
          </Link>
        </div>

        <ul className="list-unstyled components mb-5">
          <li
            className={
              activePath === "/dashboard/admin" ? "active-sidebar" : ""
            }
          >
            <Link to="/dashboard/admin">
              <MdDashboardCustomize className="me-1" /> Dashboard
            </Link>
          </li>
          <li
            className={
              activePath === "/dashboard/admin/All-kyc" ? "active-sidebar" : ""
            }
          >
            <Link to="/dashboard/admin/All-kyc">
              <IoWalletOutline className="me-1" /> Pending KYC Approvals
            </Link>
          </li>
          <li
            className={
              activePath === "/dashboard/admin/transactions"
                ? "active-sidebar"
                : ""
            }
          >
            <Link to="/dashboard/admin/transactions">
              <IoWalletOutline className="me-1" /> Transactions
            </Link>
          </li>
          <li
            className={
              activePath === "/dashboard/admin/users" ? "active-sidebar" : ""
            }
          >
            <Link to="/dashboard/admin/users">
              <ImUsers className="me-1" /> Users
            </Link>
          </li>
          <li
            className={
              activePath === "/dashboard/admin/deposit" ? "active-sidebar" : ""
            }
          >
            <Link to="/dashboard/admin/deposit">
              <LuRepeat className="me-1" /> Deposit
            </Link>
          </li>
          <li
            className={
              activePath === "/dashboard/admin/withdrawals"
                ? "active-sidebar"
                : ""
            }
          >
            <Link to="/dashboard/admin/withdrawals">
              <PiHandWithdraw className="me-1" /> Withdrawals
            </Link>
          </li>
          <li
            className={
              activePath === "/dashboard/admin/deposit-requests"
                ? "active-sidebar"
                : ""
            }
          >
            <Link to="/dashboard/admin/deposit-requests">
              <PiHandDeposit className="me-1" /> Deposit Requests
            </Link>
          </li>
          {role === "super-admin" ? (
            <>
              <li
                className={
                  activePath === "/dashboard/admin/sub-admins"
                    ? "active-sidebar"
                    : ""
                }
              >
                <Link to="/dashboard/admin/sub-admins">
                  <GoPlus className="me-1" /> Admin Users
                </Link>
              </li>
              <li
                className={
                  activePath === "/dashboard/admin/profit"
                    ? "active-sidebar"
                    : ""
                }
              >
                <Link to="/dashboard/admin/profit">
                  <LuChartColumnIncreasing className="me-1" /> Profit
                </Link>
              </li>
              <li
                className={
                  activePath === "/dashboard/admin/fund-management"
                    ? "active-sidebar"
                    : ""
                }
              >
                <Link to="/dashboard/admin/fund-management">
                  <RiFundsFill className="me-1" /> Fund Management
                </Link>
              </li>
              <li
                className={
                  activePath === "/dashboard/admin/activities"
                    ? "active-sidebar"
                    : ""
                }
              >
                <Link to="/dashboard/admin/activities">
                  <LuActivity className="me-1" /> Activities
                </Link>
              </li>
            </>
          ) : (
            ""
          )}

          {/* <li
            className={
              activePath === "/dashboard/admin/admin-wallets"
                ? "active-sidebar"
                : ""
            }
          >
            <Link to="/dashboard/admin/admin-wallets">
              <MdOutlineAccountBalanceWallet className="me-1" /> Administrator
              Wallet
            </Link>
          </li> */}
        </ul>
      </div>
    </nav>
  );
};

export default Sidebar;
